import React, {  useState } from 'react';
import LiveScoresInline from '../common/LiveScoresInline';
import SocialButtons from '../common/SocialButtons';
import EventBets from './EventBets';
import InfoButton from '../common/InfoButton';
import { useShowOnlyFirstBet, useUserSettings } from '../common/UserSettingsProvider';
import { getMatchStreamingProps, getStreamingId } from '../data/streaming/streamingUtils';
import EventInfo from './event-info/EventInfo';
import { getConfiguration } from '../data/utils/configuration';
import { getLabel } from '../data/labels';
import { getEventUrl } from '../utils/getEventUrl';
import { useGetOffsetClass } from '../utils/useGetOffsetClass';

/*export function getSocialButtonsUrl(e) {
    if (e.isLive) {
        return `https://${window.location.hostname}/${urls.live.base}/${urls.live.event}/${e.id}`;
    } else {
        return `https://${window.location.hostname}/${e.urlPathSeo || e.urlPath}`;
    }
}*/

export default function TournamentEvent(props) {
    const offsetClass = useGetOffsetClass();
    const userSettings = useUserSettings();
    const singleBetMode = useShowOnlyFirstBet();
    const addMargin = !singleBetMode && !userSettings.scrollingBets

    const e = props.data;
    const bets = e.scommessa ? [e.scommessa] : e.bets;
    const streamingMap = getMatchStreamingProps(e);
    const streaming = streamingMap && streamingMap[e.id];
    const streamingId = getStreamingId(streaming);
    const conf = getConfiguration();
    const [toggled, setToggled] = useState(false)

    function handleClick() {
        setToggled(!toggled)
    }

    return (
        <div key={e.uniqueId} className={`xs_tournamentEvent ${streamingId ? 'xs_tournamentEvent--hasStreaming' : ''}  ${toggled ? 'accordion--open' : 'accordion'} px-1 grid grid-cols-11 items-start bg-cs1 border-b border-b-cs7`}>
            <div className={`sticky ${offsetClass} py-1 pr-1 col-start-1 ${conf.iwh ? 'col-end-6' : 'col-end-5'} grid auto-rows-auto`}>
                <div className={"grid grid-flow-rows truncate" + (addMargin ? 'gap-2' : ' gap-1')}>
                        <EventInfo data={e} streamingId={streamingId} />
                    {e.score && !conf.iwh &&
                        <LiveScoresInline data={e.score} />
                    }
                    <div className="w-full flex items-center justify-between">
                        {userSettings.showInfoButton && e.info &&
                            <InfoButton data={e.info} />
                        }
                        {userSettings.showSocialButtons &&
                            <SocialButtons message={''} url={getEventUrl(e)} urlData={e} />
                        }
                    </div>
                </div>
            </div>
            <div className={`xs_eventBetsContainer ${conf.iwh ? 'col-start-6' : 'col-start-5'} col-end-13 h-full pl-1 border-l border-l-cs7 `} >
                <EventBets bets={bets} betsById={e.betsById} betId={props.betId} />
            </div>
            {conf.iwh &&
                <div className='flex w-full col-start-1 col-end-13 items-center align-items-center justify-center'>
                    <button className='btn__accordion--wh' onClick={() => handleClick()}>{!toggled ? getLabel('show_more') : getLabel('show_less') }</button></div>
            }
        </div>
    );
}
